// art work images (dummy)
import artWork1 from './art_works/art_work_1.png';
import artWork2 from './art_works/art_work_2.png';
import artWork3 from './art_works/art_work_3.png';
import artWork4 from './art_works/art_work_4.png';
import artWork5 from './art_works/art_work_5.png';
import artWork6 from './art_works/art_work_6.png';
import artWork7 from './art_works/art_work_7.png';
import artWork8 from './art_works/art_work_8.png';
import artWork9 from './art_works/art_work_9.png';

// example images (dummy)
import profileImage from './dummy_images/profile_image.png';

// default images
import profile from './default_images/profile.png';

// common
import arrowBack from './arrow_back.svg';
import brushworkLogo from './brushwork_logo.svg';
import favoriteOn from './favorite_on.svg';
import favoriteOff from './favorite_off.svg';
import notif from './notif.svg';
import search from './search.svg';
import warning from './warning.svg';

// myPage
import accountBox from './myPage/account_box.svg';
import contract from './myPage/contract.svg';
import shoppingBag from './myPage/shopping_bag.svg';
import logout from './myPage/logout.svg';
import settings from './myPage/settings.svg';
import moreVert from './myPage/more_vert.svg';
import trash from './myPage/trash.svg';

// artist
import arrowDropDown from './artist/arrow_drop_down.svg';
import dissatisfied from './artist/dissatisfied.svg';
import satisfied from './artist/satisfied.svg';

// artwork
import edit from './artwork/edit.svg';
import emergency from './artwork/emergency.svg';
import photo from './artwork/photo.svg';
import rightButtonBlack from './artwork/right_button_black.svg';
import rightButtonGrey from './artwork/right_button_grey.svg';

// chatting
import send from './chatting/send.svg';
import add from './chatting/add.svg';
import bill from './chatting/bill.svg';
import gallery from './chatting/gallery.svg';

const IMAGES = {
  // dummy
  artWork1,
  artWork2,
  artWork3,
  artWork4,
  artWork5,
  artWork6,
  artWork7,
  artWork8,
  artWork9,

  // default
  profile,

  // common
  arrowBack,
  brushworkLogo,
  favoriteOn,
  favoriteOff,
  notif,
  search,
  warning,

  // myPage
  accountBox,
  contract,
  shoppingBag,
  logout,
  settings,
  moreVert,
  trash,

  // artist
  arrowDropDown,
  dissatisfied,
  satisfied,

  // artwork
  edit,
  emergency,
  photo,
  profileImage,
  rightButtonBlack,
  rightButtonGrey,

  // chatting
  send,
  add,
  bill,
  gallery,
};

export default IMAGES;
